import {
  Box,
  Flex,
  Skeleton,
  Table,
  TableContainer,
  Tbody,
  Td,
  Text,
  Thead,
  Tr,
} from "@chakra-ui/react";

// import { useGetTotalReport } from "../../hooks/useGetTotalReport";
import {
  formatNumber,
} from "../../utils/utils";
// import { useCategoriesBooking } from "../../categorys/statementDetail/cateStatementBooking";
import { useCategoriesBookingByMonthData } from "../../categorys/statementDetail/cateStatementBookingByMonth";
import { useCategoriesLockingByMonth } from "../../categorys/statementDetail/cateStatementLockingByMont";

const TableStatementDetail = ({date}) => {

  // const {
  //   bookingData,
  //   isLoading: isLoadingBooking,
  //   isFetching: isFetchingBooking,
  // } = useCategoriesBooking(true);

  const {
    bookingByMonthData,
    isLoading: isLoadingBookingByMonth,
    isFetching: isFetchingBookingByMonth,
  } = useCategoriesBookingByMonthData(
    true,
    null,
    date?.getMonth()
      ? date.getMonth() + 1
      : null
  );

  const {
    lockingByMonthData,
    isLoading: isLoadingLockingByMonth,
    isFetching: isFetchingLockingByMonth,
  } = useCategoriesLockingByMonth(
    true,
    null,
    date?.getMonth()
      ? date.getMonth() + 1
      : null
  );

  // const booking = constantData?.booking || [];
  // const locking = constantData?.locking || [];
  const bookingByMonth = bookingByMonthData?.bookingByMonth || [];
  const lockingByMonth = lockingByMonthData?.lockingByMonth || [];

  return (
    <>
      <Flex flexDirection={"column"} gap={{ base: "16px" }}>
        <Flex
          backgroundColor="var(--color-main)"
          borderRadius={{ base: "12px" }}
          flexDirection={"column"}
        >
          <Text marginLeft={"4px"} mb={"12px"} mt={"16px"} fontWeight={"600"} fontSize={"16px"}>
            I. BÁO CÁO BOOKING
          </Text>
          <Box mb={"40px"}>
            <Box
              background="#C9DAF8"
              p={"12px 26px"}
              borderTop="1px solid #000000"
              borderRight="1px solid #000000"
              borderLeft="1px solid #000000"
            >
              <Flex alignItems={"center"} justifyContent={"center"}>
                <Text textAlign={"center"} fontWeight={"600"} fontSize={"15px"}>
                  {date?.getMonth()
                    ? `BOOKING THÁNG ${date.getMonth() + 1}`
                    : 'BÁO CÁO BOOKING'}
                </Text>
                {/* <Box position={"relative"}>
                  <ChevronDownIcon boxSize={10} color="gray.500" />
                  <InputGroup
                    maxW={"255px"}
                    zIndex={3}
                    w={"100px"}
                    h={"0"}
                    // opacity={1}
                    // visibility="hidden"
                    background={"transparent"}
                    position={"absolute"}
                    top={0}
                    left={0}
                    border={"none"}
                  >
                    <DatePicker
                      selected={dateBookingByMonth}
                      onChange={handleBookingByMonthChange}
                      dateFormat="MM/yyyy"
                      showMonthYearPicker
                      placeholderText="Tháng năm"
                      className="datePickerStyle"
                      locale="vi"
                      customInput={
                        <div
                          style={{
                            border: "none",
                            outline: "none",
                            background: "transparent",
                          }}
                        />
                      }
                    />
                    <InputRightElement pointerEvents="none" h={"44px"}>
                      <Image src={ChevronDownIcon} />
                    </InputRightElement>
                  </InputGroup>
                </Box> */}
              </Flex>
            </Box>
            <Box width={"100%"} height={"100%"}>
              <TableContainer
                w={"100%"}
                border="1px solid #000000"
                // overflowY="auto"
                maxW={"100vw"}
              >
                <Skeleton
                  isLoaded={
                    !isLoadingBookingByMonth && !isFetchingBookingByMonth
                  }
                >
                  {/* <Table w={"100%"} variant="unstyled" maxW={"100vw"}> */}
                  <Table
                    variant="simple"
                    size="sm"
                    width="100%"
                    sx={{ tableLayout: "fixed" }}
                  >
                    <Thead
                      position="sticky"
                      top="0"
                      zIndex="1"
                      w={"100%"}
                      h={"41px"}
                      color="white"
                      fontWeight="400"
                      background="#C9DAF8"
                    >
                      <Tr>
                        {bookingByMonth?.headers?.map((e, index) => {
                          let textAlign = index === 0 ? "start" : "start";
                          return (
                            <Td
                              p={"16px 8px 8px 8px"}
                              w={"10%"}
                              border="1px solid #000000"
                              color={"#51607B"}
                              key={index}
                              minW={"120px"}
                            >
                              <Text
                                fontSize={{ base: "14px" }}
                                maxW={"100px"}
                                textAlign={"start"}
                                whiteSpace="normal"
                                wordBreak={"break-word"}
                                overflowWrap={"break-word"}
                                verticalAlign={"top"}
                                lineHeight={"19px"}
                              >
                                {e}
                              </Text>
                            </Td>
                          );
                        })}
                      </Tr>
                    </Thead>
                    <Tbody w={"100%"} h={"100%"}>
                      {bookingByMonth?.rows?.length > 0 ? (
                        bookingByMonth?.rows?.map((e, rowIndex) => {
                          const values = Object.entries(e)
                            .filter(
                              ([key]) => key !== "manager" && key !== "total"
                            )
                            .map(([, value]) => value);
                          return (
                            <Tr key={rowIndex} h={"72px"}>
                              <Td
                                bg={
                                  rowIndex % 2 === 0
                                    ? "var(--color-main)"
                                    : "var(--fill-avatar)"
                                }
                                border="1px solid #000000"
                                fontSize={"14px"}
                                maxW={"120px"}
                                whiteSpace={"normal"}
                                lineHeight={"19.6px"}
                              >
                                {e?.manager || ""}
                              </Td>
                              {values.map((keyvalue, index) => {
                                let width = "20%";
                                let widthText = "100%";
                                let textAlign = "center";
                                let whiteSpace = "inherit";
                                return (
                                  <Td
                                    p={"16px 8px 8px 8px"}
                                    w={width}
                                    key={index}
                                    border="1px solid #000000"
                                    bg={
                                      rowIndex % 2 === 0
                                        ? "var(--color-main)"
                                        : "var(--fill-avatar)"
                                    }
                                  >
                                    <Box
                                      fontSize={{ base: "14px" }}
                                      lineHeight={"19.6px"}
                                      textAlign={"start"}
                                      fontWeight={500}
                                      color={"#293755"}
                                      w={widthText}
                                      whiteSpace={whiteSpace}
                                      overflow="hidden"
                                      maxW={"120px"}
                                    >
                                      <Text>{keyvalue}</Text>
                                    </Box>
                                  </Td>
                                );
                              })}
                              <Td
                                bg={
                                  rowIndex % 2 === 0
                                    ? "var(--color-main)"
                                    : "var(--fill-avatar)"
                                }
                                border="1px solid #000000"
                                textAlign="center"
                                fontSize={"14px"}
                              >
                                {e?.total || 0}
                              </Td>
                            </Tr>
                          );
                        })
                      ) : (
                        <Tr>
                          <Td
                            colSpan={bookingByMonth?.headers?.length}
                            textAlign="center"
                            padding={"40px 0"}
                          >
                            Không có dữ liệu
                          </Td>
                        </Tr>
                      )}
                    </Tbody>
                  </Table>
                </Skeleton>
              </TableContainer>
            </Box>
          </Box>

          <Text marginLeft={"4px"} mb={"12px"} fontWeight={"600"} fontSize={"16px"}>
            II. BÁO CÁO CỌC
          </Text>
          <Box mb={"40px"}>
            <Box
              background="#C9DAF8"
              p={"12px 26px"}
              borderTop="1px solid #000000"
              borderRight="1px solid #000000"
              borderLeft="1px solid #000000"
            >
              <Flex alignItems={"center"} justifyContent={"center"}>
                <Text textAlign={"center"} fontWeight={"600"} fontSize={"15px"}>
                  {date?.getMonth()
                    ? `CỌC THÁNG ${date.getMonth() + 1}`
                    : "BÁO CÁO CỌC"}
                </Text>
                {/* <Box position={"relative"}>
                  <ChevronDownIcon boxSize={10} color="gray.500" />
                  <InputGroup
                    maxW={"255px"}
                    zIndex={3}
                    w={"100px"}
                    h={"0"}
                    // opacity={1}
                    // visibility="hidden"
                    background={"transparent"}
                    position={"absolute"}
                    top={0}
                    left={0}
                    border={"none"}
                  >
                    <DatePicker
                      selected={dateLockingByMonth}
                      onChange={handleLockingByMonthChange}
                      dateFormat="MM/yyyy"
                      showMonthYearPicker
                      placeholderText="Tháng năm"
                      className="datePickerStyle"
                      locale="vi"
                      customInput={
                        <div
                          style={{
                            border: "none",
                            outline: "none",
                            background: "transparent",
                          }}
                        />
                      }
                    />
                    <InputRightElement pointerEvents="none" h={"44px"}>
                      <Image src={ChevronDownIcon} />
                    </InputRightElement>
                  </InputGroup>
                </Box> */}
              </Flex>
            </Box>
            <Box width={"100%"} height={"100%"}>
              <TableContainer
                w={"100%"}
                border="1px solid #000000"
                overflowY="auto"
              >
                <Skeleton
                  isLoaded={
                    !isLoadingLockingByMonth && !isFetchingLockingByMonth
                  }
                >
                  <Table w={"100%"} variant="unstyled">
                    <Thead
                      position="sticky"
                      top="0"
                      zIndex="1"
                      w={"100%"}
                      h={"41px"}
                      color="white"
                      fontWeight="400"
                      background="#C9DAF8"
                    >
                      <Tr h={{ base: "41px" }}>
                        {lockingByMonth?.headers?.map((e, index) => {
                          let width = "20%";
                          let textAlign = index === 0 ? "start" : "center";
                          return (
                            <Td
                              key={index}
                              border="1px solid #000000"
                              color={"#51607B"}
                              fontSize={{ base: "14px" }}
                              w={width}
                              p={"0px"}
                            >
                              <Box
                                textAlign={"start"}
                                p={"16px 8px 8px 8px"}
                                borderBottom={
                                  index !== 0 ? "1px solid #000000" : "none"
                                }
                                fontSize={"14px"}
                              >
                                {e}
                              </Box>
                              {!(index === 0) && (
                                <Flex alignItems={"center"}>
                                  <Flex
                                    flex={1}
                                    minW={"130px"}
                                    maxW={"130px"}
                                    textAlign={"center"}
                                    p={"16px 8px 8px 8px"}
                                    justifyContent={"center"}
                                    alignItems={"center"}
                                    h={"100%"}
                                    minH={"42px"}
                                    borderRight={"1px solid #000000"}
                                    fontSize={"14px"}
                                  >
                                    Số lượng
                                  </Flex>
                                  <Flex
                                    h={"100%"}
                                    flex={1}
                                    minW={"130px"}
                                    maxW={"130px"}
                                    textAlign={"center"}
                                    p={"16px 8px 8px 8px"}
                                    justifyContent={"center"}
                                    minH={"42px"}
                                    alignItems={"center"}
                                    fontSize={"14px"}
                                  >
                                    Doanh số
                                  </Flex>
                                </Flex>
                              )}
                            </Td>
                          );
                        })}
                      </Tr>
                    </Thead>
                    <Tbody w={"100%"} h={"100%"}>
                      {lockingByMonth?.rows?.length > 0 ? (
                        lockingByMonth?.rows?.map((e, rowIndex) => {
                          const isLastRow = Object.values(e).every(
                            (val) =>
                              typeof val !== "object" ||
                              val === null ||
                              !("count" in val && "price" in val)
                          );

                          const values = Object.entries(e)
                            .filter(([key]) =>
                              isLastRow
                                ? key !== "manager" && key !== "total"
                                : key !== "manager" &&
                                  key !== "total" &&
                                  key !== "totalPrice" &&
                                  key !== "price"
                            )
                            .map(([, value]) => value);

                          return (
                            <Tr key={rowIndex} h={"72px"}>
                              <Td
                                bg={
                                  rowIndex % 2 === 0
                                    ? "var(--color-main)"
                                    : "var(--fill-avatar)"
                                }
                                border="1px solid #000000"
                                fontSize={"14px"}
                                maxW={"120px"}
                                whiteSpace={"normal"}
                                lineHeight={"19.6px"}
                                p={"16px 8px 8px 8px"}
                              >
                                {e?.manager || ""}
                              </Td>
                              {values.map((keyvalue, index) =>
                                renderTableCell(
                                  keyvalue,
                                  index,
                                  isLastRow,
                                  rowIndex
                                )
                              )}

                              <Td
                                bg={
                                  rowIndex % 2 === 0
                                    ? "var(--color-main)"
                                    : "var(--fill-avatar)"
                                }
                                border="1px solid #000000"
                                textAlign="center"
                                p={"0px"}
                              >
                                <Flex alignItems={"center"}>
                                  <Flex
                                    flex={1}
                                    minW={"130px"}
                                    maxW={"130px"}
                                    textAlign={"center"}
                                    p={"16px 8px 8px 8px"}
                                    justifyContent={"center"}
                                    alignItems={"center"}
                                    h={"100%"}
                                    minH={"72px"}
                                    borderRight={"1px solid #000000"}
                                    fontSize={"14px"}
                                  >
                                    {e?.total || "0"}
                                  </Flex>
                                  {!isLastRow && (
                                    <Flex
                                      h={"100%"}
                                      flex={1}
                                      minW={"130px"}
                                      maxW={"130px"}
                                      textAlign={"center"}
                                      p={"16px 8px 8px 8px"}
                                      justifyContent={"center"}
                                      minH={"72px"}
                                      alignItems={"center"}
                                      fontSize={"14px"}
                                    >
                                      {e?.price ? formatNumber(e?.price) : "0"}
                                    </Flex>
                                  )}
                                </Flex>
                              </Td>
                            </Tr>
                          );
                        })
                      ) : (
                        <Tr>
                          <Td
                            colSpan={lockingByMonth?.headers?.length}
                            textAlign="center"
                            padding={"40px 0"}
                          >
                            Không có dữ liệu
                          </Td>
                        </Tr>
                      )}
                    </Tbody>
                  </Table>
                </Skeleton>
              </TableContainer>
            </Box>
          </Box>
        </Flex>
      </Flex>
    </>
  );
};

const renderTableCell = (keyvalue, index, isLastRow, rowIndex) => {
  const width = "20%";
  const bgColor =
    rowIndex % 2 === 0 ? "var(--color-main)" : "var(--fill-avatar)";

  if (isLastRow) {
    return (
      <Td key={index} w={width} border="1px solid #000000" bg={bgColor}>
        <Box textAlign="center">
          <Text fontSize={"14px"}>{keyvalue}</Text>
        </Box>
      </Td>
    );
  }

  return (
    <Td key={index} w={width} border="1px solid #000000" bg={bgColor} p="0">
      <Flex alignItems="center">
        <Flex
          flex={1}
          minW="130px"
          maxW="130px"
          justifyContent="center"
          p="16px"
          borderRight={"1px solid #000000"}
          alignItems={"center"}
          minH={"72px"}
          fontSize={"14px"}
        >
          {keyvalue?.count || "0"}
        </Flex>
        <Flex
          flex={1}
          minW="130px"
          maxW="130px"
          justifyContent="center"
          p="16px"
          minH={"72px"}
          alignItems={"center"}
          fontSize={"14px"}
        >
          {keyvalue?.price ? formatNumber(keyvalue?.price) : "0"}
        </Flex>
      </Flex>
    </Td>
  );
};

export default TableStatementDetail;
